import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[bcdInsertionPoint]'
})
export class InsertionPointDirective {

  constructor(
    public directiveViewContainerRef: ViewContainerRef
  ) { }

}
